import axios from "axios";

export const uploadComprobantePago = async (id, body) => {
debugger
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/invoices/${id}/comprobante`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: body,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
